
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAutomationInputModal as ObcAutomationInputModalElement} from '@oicl/openbridge-webcomponents/dist/automation/automation-input-modal/automation-input-modal.js';
 
 
 

 
 export const ObcAutomationInputModal = createComponent({
   react: React,
   tagName: 'obc-automation-input-modal',
   elementClass: ObcAutomationInputModalElement,
   events: {
     
   }
  });
 
 